import { NMessage } from "@nebulajs/web";
import { createWebHistory, createRouter } from "vue-router";
import access from "./access";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../views/home.vue"),
    },
    {
      path: "/account/login",
      name: "account-login",
      component: () => import("../views/account/login/index.vue"),
    },
    {
      path: "/system",
      name: "system",
      meta: { access: 10000 },
      component: () => import("../views/home.vue"),
      children: [
        {
          path: "/system/account",
          name: "system-account",
          component: () => import("../views/system/account/index.vue"),
        },
        {
          path: "/system/account-access",
          name: "system-account-access",
          component: () => import("../views/system/account-access/index.vue"),
        },
        {
          path: "/system/organization",
          name: "system-organization",
          component: () => import("../views/system/organization/index.vue"),
        },
        {
          path: "/system/organization-member",
          name: "system-organization-member",
          component: () => import("../views/system/organization-member/index.vue"),
        },
      ],
    },
    {
      path: "/book",
      name: "book",
      meta: { access: 20000 },
      component: () => import("../views/home.vue"),
      children: [
        {
          path: "/book/point",
          name: "book-point",
          component: () => import("../views/book/point/index.vue"),
        },
        {
          path: "/book/evaluate",
          name: "book-evaluate",
          component: () => import("../views/book/evaluate/index.vue"),
        },
        {
          path: "/book/paragraph",
          name: "book-paragraph",
          component: () => import("../views/book/paragraph/index.vue"),
        },
        {
          path: "/book/page",
          name: "book-page",
          component: () => import("../views/book/page/index.vue"),
        },
        {
          path: "/book/translate",
          name: "book-translate",
          component: () => import("../views/book/translate/index.vue"),
        },
        {
          path: "/book/task",
          name: "book-task",
          component: () => import("../views/book/task/index.vue"),
        },
        {
          path: "/book/analysis",
          name: "book-analysis",
          component: () => import("../views/book/analysis/index.vue"),
        },
      ],
    },
    {
      path: "/book/point/make",
      name: "book-point-make",
      component: () => import("../views/book/point-make/index.vue"),
    },
    {
      path: "/book/paragraph/make",
      name: "book-paragraph-make",
      component: () => import("../views/book/paragraph-make/index.vue"),
    },
    {
      path: "/book/page/make",
      name: "book-page-make",
      component: () => import("../views/book/page-make/index.vue"),
    },
  ],
});

router.beforeEach(async (to, from) => {
  const success = await access.updateSystemAccess();
  if (!success) {
    access.token = "";
    return "/account/login";
  }
  if (to.path === "/") {
    const bookAccess = access.findControlAccess((control) => {
      if (!control.path || !access.oid) return;
      return control.key >= 20000 && control.key < 30000;
    });
    if (bookAccess) return bookAccess.path;
    const systemAccess = access.findControlAccess((control) => {
      if (!control.path) return;
      return control.key >= 10000 && control.key < 20000;
    });
    if (systemAccess) return systemAccess.path;
    if (from.path === "/account/login") {
      NMessage.error({ content: "暂无权限，请联系管理员授权" });
    }
    return "/account/login";
  }

  return true;
});

router.onError((error) => {
  console.warn("Router error:", error);
});

export default router;
